import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import classnames from 'classnames';

import Rate from '../Rate/Rate';

import styles from './Score.module.less';

export default memo(({ data }) => {
  const type = 1;

  return type === 1 ? (
    <div className={styles.detail_score}>
      <div className={styles.score_info}>
        <div className={styles.score_info_left}>
          <div className={styles.left_line_one}>
            <span className={styles.left_line_one_score_num}>{data?.avgScore}</span>分
          </div>
          <div className={styles.left_line_two}>
            <Rate score={data?.avgScore} />
          </div>
          <div className={styles.left_line_three}>{data?.commentUserNum}人已评分</div>
        </div>
        <div className={styles.score_info_right}>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  data?.commentUserNum ? (data?.starUserNum?.five / data?.commentUserNum) * 100 : 0,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {data?.commentUserCount !== 0
                ? `${parseInt(
                    data?.commentUserNum
                      ? (data?.starUserNum?.five / data?.commentUserNum) * 100
                      : 0,
                    10,
                  )}%`
                : `0%`}
            </div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  data?.commentUserNum ? (data?.starUserNum?.four / data?.commentUserNum) * 100 : 0,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {data?.commentUserCount !== 0
                ? `${parseInt(
                    data?.commentUserNum
                      ? (data?.starUserNum?.four / data?.commentUserNum) * 100
                      : 0,
                    10,
                  )}%`
                : `0%`}
            </div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  data?.commentUserNum
                    ? (data?.starUserNum?.three / data?.commentUserNum) * 100
                    : 0,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {data?.commentUserCount !== 0
                ? `${parseInt(
                    data?.commentUserNum
                      ? (data?.starUserNum?.three / data?.commentUserNum) * 100
                      : 0,
                    10,
                  )}%`
                : `0%`}
            </div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  data?.commentUserNum ? (data?.starUserNum?.two / data?.commentUserNum) * 100 : 0,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {data?.commentUserCount !== 0
                ? `${parseInt(
                    data?.commentUserNum
                      ? (data?.starUserNum?.two / data?.commentUserNum) * 100
                      : 0,
                    10,
                  )}%`
                : `0%`}
            </div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 ${parseInt(
                  data?.commentUserNum ? (data?.starUserNum?.one / data.commentUserNum) * 100 : 0,
                  10,
                )}%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>
              {data.commentUserCount !== 0
                ? `${parseInt(
                    data?.commentUserNum ? (data?.starUserNum?.one / data.commentUserNum) * 100 : 0,
                    10,
                  )}%`
                : `0%`}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className={styles.detail_score}>
      <div className={styles.score_info}>
        <div className={styles.score_info_left}>
          <div className={styles.left_line_one}>
            <span className={styles.left_line_one_score_num}>{data.averageStar || 0}</span>分
          </div>
          <div className={styles.left_line_two}>
            <Rate score={data.averageStar} />
          </div>
          <div className={styles.left_line_three}>{data.commentUserCount || 0}人已评分</div>
        </div>
        <div className={styles.score_info_right}>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 0%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>0%</div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 0%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>0%</div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 100%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>100%</div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 0%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>0%</div>
          </div>
          <div className={styles.right_line}>
            <div className={styles.right_line_stars}>
              <span className={classnames('star', 'iconfont', 'icon-staron')} />
            </div>
            <div
              className={styles.right_line_progress_bar}
              style={{
                background: `linear-gradient(to right, #B7BDC7 0%, #F4F7FC 0%)`,
              }}
            />
            <div className={styles.right_line_progress_num}>0%</div>
          </div>
        </div>
      </div>
    </div>
  );
});
